import { DynamicContentType } from '../../types/content.types.js'
import { LucideIconName } from '../../types/lucide.types.js'

export type TipsBoxData = {
  alignment: string
  content: string
  marginBottom: string
}

export const tipsbox: DynamicContentType<TipsBoxData> = {
  name: 'tipsbox',
  viewName: 'Tipsruta',
  featureKey: 'tipsbox',
  icon: LucideIconName.Tag,
  default: true,
  uuid: '',
  data: {
    alignment: 'left',
    content: '<p>Mitt textinnehåll</p>',
    marginBottom: '0.5rem',
  },
}
